export default function initMobileMenu() {

	const burger = document.querySelector('.header__burger')
	const mobilemenu = document.querySelector('.mobilemenu')

	burger.addEventListener('click', () => {
		if(burger.classList.contains('opened')) {
			document.body.classList.remove('popup-opened')
		}
		burger.classList.toggle('opened')
		mobilemenu.classList.toggle('opened')
		document.body.classList.toggle('mobilemenu-opened')

	})
}
